// extracted by mini-css-extract-plugin
module.exports = {"default":"PostStats--default--1Iwii","dot":"PostStats--dot--kvdgr","author":"PostStats--author--3kkhh"};